import React from "react";
import fileIcon from "../../assets/file.svg";

const AttachIcon: React.FC = () => (
  <img src={fileIcon} alt="" aria-hidden="true" width="20" height="20" />
);

export default AttachIcon;
